import Plyr from 'plyr';

export default class VideoPlayers {

    constructor()
    {
        this.play_buttons = document.querySelectorAll('[data-open-video]');
        this.popup = document.querySelectorAll('[data-video-popup]')
        this.is_init = false;

        document.addEventListener('scroll', () => {
            if (window.scrollY > 300 && !this.is_init) {
                this.init();
                this.is_init = true;
            } else {
                return false;
            }
        });
    }

    init()
    {

        if (!this.play_buttons && !this.popup) {
            return false;
        }

        const max = this.popup.length;

        for (let i = 0; i < max; i++) {
            const elem = this.play_buttons[i];
            const uniq = elem.dataset.openVideo;


            if (uniq) {
                const video = new VideoPlayer(uniq);
                video.init();
            }
        }
    }
}

class VideoPlayer {
    constructor(uniq)
    {
        this.uniq = uniq;
        this.play_button = document.querySelector('[data-open-video="' + uniq + '"]');
        this.hide_button = document.querySelector('[data-hide-popup="' + uniq + '"]');
        this.player_popup = document.querySelector('[data-video-popup="' + uniq + '"]');
      this.pause_button = document.querySelector('[data-pause-button="' + uniq + '"]');
        this.player = document.querySelector('[data-video-player="' + uniq + '"]');
        this.plyr_player = false;
        this.iframe = false;
    }

    init()
    {

        if (!this.uniq || !this.player_popup || !this.play_button) {
            return false;
        }

        this.iframe = this.player_popup.querySelector('iframe');
        this.iframe.src = this.iframe.dataset.src;
        this.initPlayer();

      this.play_button.addEventListener('click', () => {
        this.player_popup.classList.toggle('is-open');
        this.plyr_player.stop();
      })

        this.hide_button.addEventListener('click', () => {
            this.player_popup.classList.toggle('is-open');
            this.plyr_player.stop();
        })

    }

    initPlayer()
    {
        const options = {
            hideControls: false,
        };

        let that = this;

        this.plyr_player = new Plyr(that.player, options);
    }
}
